import React, { Component } from 'react';
import { Card, Row, Col, Badge } from 'reactstrap';
import { ActiveInactiveStatusBadge, StyledCard } from '../../Base/Common/CommonUIComponents';
import { injectIntl } from "react-intl";
import { getAPI } from '../../Base/API';

export class TemplatesConfig extends Component {
    static displayName = TemplatesConfig.name;
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            block: true,
            modal: false,
        }
    }


    componentDidMount() {
        this.getTemplates();

    }

    getTemplates() {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {

                this.setState({ templateList: this.groupTemplates(data.response), block: false });
            }
            else {
                this.setState({ templateList: [], block: false });
            }
        }, '/api/Voucher/v1/Config/notificationTemplates');
    }

    //Language variants (same name, type and hotel) are shown as a single card with one badge per language
    groupTemplates = (templates) => {
        const groups = [];

        (templates || []).forEach(template => {
            const group = groups.find(g => g.name === template.name && g.type === template.type && g.hotelId === template.hotelId);

            if (group) {
                group.variants.push(template);
                group.active = group.active || template.active;
                group.hasStripo = group.hasStripo || !!template.templateJson;
            }
            else {
                groups.push({
                    name: template.name,
                    type: template.type,
                    hotelId: template.hotelId,
                    active: template.active,
                    hasStripo: !!template.templateJson,
                    variants: [template]
                });
            }
        });

        groups.forEach(g => g.variants.sort((a, b) => (a.languageCode || '').localeCompare(b.languageCode || '')));

        return groups;
    }

    goToTemplateDetails = (templateId) => {
        this.props.history.push({ pathname: `/TemplateDetails/${templateId}` });
    }


    render() {
        const { templateList } = this.state;


        return (
            <StyledCard icon={'fa-regular fa-file'} title={'navbar.TemplatesConfig'} error={this.state.error} block={this.state.block}>
                <Row>
                    <Col>
                        <Row>
                            {templateList?.map((group, index) =>
                                <Col key={index} className='col-4 mb-3'>
                                    <Card className="shadow pointer overbglight p-3" onClick={_ => this.goToTemplateDetails((group.variants.find(v => v.active) || group.variants[0]).id)} body>
                                        <Row>
                                            <Col><b>{group.name}</b></Col>
                                            <Col className="text-right col-3 pl-0">
                                                <ActiveInactiveStatusBadge status={group.active} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col> {group.type} </Col>
                                            <Col className="text-right">
                                                {group.hasStripo ?
                                                    <>
                                                        <Badge color="primary" className="mr-1">Stripo</Badge>
                                                        {group.variants.filter(v => v.languageCode).map((variant, i) =>
                                                            <Badge color="secondary" className="mr-1" key={i}>
                                                                <span className={`flag-icon flag-icon-${variant.languageCode === 'EN' ? 'gb' : variant.languageCode.toLowerCase()} mr-1`} />
                                                                {variant.languageCode}
                                                            </Badge>
                                                        )}
                                                    </>
                                                : ''}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            </StyledCard>
        );
    }
}

export default injectIntl(TemplatesConfig);
